import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MessagesSquare } from "lucide-react";
import api from "@/lib/api";

export function useSupportUnread() {
    const [unread, setUnread] = useState(0);
    const { pathname } = useLocation();
    useEffect(() => {
        const load = () => api.get("/support/unread-count").then((r) => setUnread(r.data.unread || 0)).catch(() => {});
        load();
        const t = setInterval(load, 45000);
        return () => clearInterval(t);
    }, [pathname]);
    return unread;
}

export function MessagesLink({ isDark, to = "/messages" }) {
    const unread = useSupportUnread();
    return (
        <Link
            to={to}
            className="relative p-2 rounded-full transition-colors hover:bg-black/5 hidden sm:inline-flex"
            title="Mes échanges avec les professeurs"
            data-testid="header-messages-link"
        >
            <MessagesSquare className="w-5 h-5" style={{ color: isDark ? "rgba(244,238,223,0.85)" : "var(--text-secondary)" }} />
            {unread > 0 && (
                <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center" style={{ background: "var(--gold-400)", color: "#1A1208" }} data-testid="header-messages-badge">
                    {unread > 9 ? "9+" : unread}
                </span>
            )}
        </Link>
    );
}
